
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/try-demo",
      function () {
        return require("private-next-pages/try-demo/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/try-demo"])
      });
    }
  